var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(((_vm.$vuetify.t('$vuetify.common.poweredBy')) + " "))+"\n  "),_c('a',{staticStyle:{"color":"#e97283"},attrs:{"href":"http://gosnappy.io"}},[_vm._v("Snappy")])])}
var staticRenderFns = []

export { render, staticRenderFns }